import { Construction } from 'lucide-react';

import { useTranslation } from '../../context/LanguageContext';
import type { TranslationKey } from '../../i18n';

/**
 * A tab that has a route and a sidebar entry but no implementation yet.
 *
 * Deliberately blunt rather than a mocked-up empty state: the surrounding phases
 * build these one at a time, and a placeholder that looks like a real but empty
 * feature is indistinguishable from a broken one. Saying which phase owns it
 * means nobody files a bug against work that has not started.
 */
export function PlaceholderPage({
  titleKey,
  bodyKey,
}: Readonly<{ titleKey: TranslationKey; bodyKey: TranslationKey }>) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center max-w-md mx-auto">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-800 border border-slate-700 mb-4">
        <Construction className="h-5 w-5 text-slate-500" />
      </div>
      <p className="text-sm font-semibold text-slate-300">{t(titleKey)}</p>
      <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">{t(bodyKey)}</p>
    </div>
  );
}
